import styled from 'styled-components';

const Item = styled.div`
	flex-shrink: 0;
	width: 100%;
`;

export default Item;
